document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  const headerWrapper = document.querySelector('.ambassadors__header--wrapper');
  const headerTitle = document.querySelector('.ambassadors__header--body h1');
  const headerButton = document.querySelector('.ambassadors__header--link-1');

  if (headerWrapper) {
    gsap.fromTo(headerWrapper,
      { y: 30, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.7,
        ease: "power2.out",
        scrollTrigger: {
          trigger: headerWrapper,
          start: "top 85%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  if (headerTitle) {
    gsap.fromTo(headerTitle,
      { y: -20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        delay: 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: headerTitle,
          start: "top 85%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  if (headerButton) {
    gsap.fromTo(headerButton,
      { y: 20, scale: 0.96, opacity: 0 },
      {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 0.55,
        delay: 0.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: headerButton,
          start: "top 85%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  ScrollTrigger.refresh();
});
